var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivation2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 242,
    viewBox: "0 0 293 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.191 39.0257C265.636 61.6189 314.727 121.212 274.55 181.87C230.825 247.894 132.957 188.983 113.291 215.092C113.291 215.092 73.4947 270.151 20.8978 222.27C-31.7039 174.389 22.627 87.9808 105.218 32.5391C143.647 6.74227 205.074 5.64016 241.191 39.0257Z",
    fill: "#E8F2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.612 166.352H143.426V224.075H175.612V166.352Z",
    fill: "#0054A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.106 228.432H120.859C120.859 217.875 129.444 209.316 140.034 209.316H179.937C190.526 209.316 199.111 217.875 199.111 228.432H199.106Z",
    fill: "#0054A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.762 41.0547H53.3474C48.8365 41.0547 45.1797 44.7273 45.1797 49.2576V186.807C45.1797 191.338 48.8365 195.01 53.3474 195.01H259.762C264.273 195.01 267.93 191.338 267.93 186.807V49.2576C267.93 44.7273 264.273 41.0547 259.762 41.0547Z",
    fill: "#192B4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.447 194.414H48.1836C43.3616 194.414 39.4531 190.518 39.4531 185.71V49.6257C39.4531 44.8184 43.3616 40.9219 48.1836 40.9219H254.443C259.265 40.9219 263.173 44.8184 263.173 49.6257V185.715C263.173 190.522 259.265 194.419 254.443 194.419L254.447 194.414Z",
    fill: "#0054A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.455 47.7812H44.9922V184.437H256.455V47.7812Z",
    fill: "#F2F5FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.387 195.012H175.272V205.275L144.387 195.012Z",
    fill: "#172D59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.387 209.008H173.4",
    stroke: "#172D59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.455 110.852L150.94 166.085L85.4258 110.852L139.221 59.7211C145.773 53.494 156.108 53.494 162.66 59.7211L216.455 110.852Z",
    fill: "#219CFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.159 83.9766H96.6562V148.358H206.159V83.9766Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216.455 173.55H85.4258V111.035L150.984 145.086L216.455 111.035V173.55Z",
    fill: "#219CFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.875 144.625L126.605 156.755",
    stroke: "#172D59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M204.754 106.37C211.215 106.37 216.453 101.148 216.453 94.7063C216.453 88.2648 211.215 83.043 204.754 83.043C198.293 83.043 193.055 88.2648 193.055 94.7063C193.055 101.148 198.293 106.37 204.754 106.37Z",
    fill: "#FF724F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.722 97.0391H107.887V103.571H168.722V97.0391Z",
    fill: "#EBECF7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.864 111.969H107.887V119.433H195.864V111.969Z",
    fill: "#EBECF7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.44 104.977C199.92 104.977 199.51 104.837 199.21 104.557C198.93 104.257 198.79 103.857 198.79 103.357C198.79 102.837 198.93 102.447 199.21 102.187C199.51 101.927 199.92 101.797 200.44 101.797H203.8V87.0666H205.66L201.25 89.7366C200.87 89.9566 200.51 90.0466 200.17 90.0066C199.85 89.9466 199.57 89.8066 199.33 89.5866C199.11 89.3466 198.96 89.0666 198.88 88.7466C198.8 88.4266 198.82 88.1066 198.94 87.7866C199.08 87.4466 199.34 87.1666 199.72 86.9466L203.86 84.4566C204.26 84.2166 204.66 84.0166 205.06 83.8566C205.46 83.6766 205.83 83.5866 206.17 83.5866C206.59 83.5866 206.94 83.7066 207.22 83.9466C207.5 84.1666 207.64 84.5366 207.64 85.0566V101.797H210.7C211.22 101.797 211.62 101.927 211.9 102.187C212.2 102.447 212.35 102.837 212.35 103.357C212.35 103.877 212.2 104.277 211.9 104.557C211.62 104.837 211.22 104.977 210.7 104.977H200.44Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7054_22789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.986 153.175C252.915 153.309 248.445 156.579 248.445 156.579C248.445 156.579 249.433 163.601 253.441 166.374C257.848 169.422 264.072 163.863 264.072 163.863C264.072 163.863 269.025 165.033 271.659 154.781C272.263 152.429 268.775 152.23 264.565 152.664C259.136 153.222 252.986 153.175 252.986 153.175V153.175Z",
    fill: "url(#paint0_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.632 177.133C246.38 175.938 248.314 175.037 250.363 174.482C251.134 174.274 255.29 175.475 257.86 175.416C261.387 175.335 264.978 173.739 267.885 174.46C270.773 175.175 273.137 176.11 274.502 177.075C278.587 179.965 280.986 185.352 282.448 190.689C279.68 193.514 276.197 194.77 276.197 194.77L275.553 220.708L260.128 228.555L242.521 219.766L243.152 194.419C243.152 194.419 237.561 191.83 237.151 190.888C236.741 189.947 239.699 180.507 244.632 177.135V177.133Z",
    fill: "#FF6741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.409 190.774C237.409 190.774 229.917 211.427 247.002 219.916C250.55 219.447 249.185 213.589 249.185 213.589C249.185 213.589 241.762 211.956 243.991 194.727C241.939 193.048 237.409 190.773 237.409 190.773V190.774Z",
    fill: "url(#paint1_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.085 190.774C282.085 190.774 287.24 212.333 272.492 219.916C268.944 219.447 270.309 213.589 270.309 213.589C270.309 213.589 276.292 210.66 275.503 194.727C277.555 193.048 282.085 190.773 282.085 190.773V190.774Z",
    fill: "url(#paint2_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.574 198.652H242.885C242.571 198.652 242.316 198.906 242.316 199.218V220.801C242.316 221.114 242.571 221.367 242.885 221.367H275.574C275.889 221.367 276.143 221.114 276.143 220.801V199.218C276.143 198.906 275.889 198.652 275.574 198.652Z",
    fill: "url(#paint3_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.981 228.103C287.109 227.219 278.162 227.694 278.162 227.694L277.798 228.674L277.195 233.544C277.195 233.544 285.716 235.071 289.916 235.067C290.345 235.067 290.737 235.003 291.095 234.892C291.223 234.778 291.348 234.659 291.466 234.531C293.248 232.596 292.733 229.754 290.98 228.102L290.981 228.103Z",
    fill: "url(#paint4_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.592 227.418L277.107 227.482C277.921 227.517 278.688 227.912 279.235 228.577C279.782 229.242 280.064 230.123 280.016 231.019C279.978 231.734 279.683 232.402 279.196 232.877C278.709 233.352 278.071 233.593 277.423 233.546L275.105 233.382L275.592 227.418Z",
    fill: "url(#paint5_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.647 227.63C228.539 226.865 237.471 227.613 237.471 227.613L237.81 228.603L238.29 233.491C238.29 233.491 229.734 234.757 225.536 234.625C225.108 234.611 224.717 234.535 224.362 234.414C224.237 234.296 224.115 234.174 224 234.041C222.267 232.053 222.853 229.226 224.647 227.629V227.63Z",
    fill: "url(#paint6_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.046 227.418L238.529 227.436C237.715 227.445 236.938 227.816 236.375 228.465C235.811 229.113 235.507 229.984 235.533 230.882C235.553 231.598 235.831 232.275 236.306 232.765C236.78 233.254 237.412 233.514 238.061 233.488L240.382 233.395L240.046 227.418Z",
    fill: "url(#paint7_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.062 212.829C290.306 208.811 286.012 208.159 282.357 210.038C282.294 210.121 259.149 221.915 238.738 227.085C239.323 228.948 239.623 230.93 239.689 232.877C239.7 233.311 239.693 233.74 239.668 234.162C255.319 233.363 272.307 228.172 286.905 223.611C291.431 222.16 294.008 217.282 292.062 212.83V212.829Z",
    fill: "#0074EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.702 233.184C275.641 230.939 276.08 228.848 277.019 226.913C277.046 226.825 277.078 226.74 277.107 226.652C275.941 226.293 274.436 225.807 272.458 225.139C257.964 220.207 246.907 215.228 236.354 209.495C232.255 207.268 227.593 208.76 226.281 213.584C225.109 217.89 227.682 221.566 231.587 222.858C243.269 226.723 237.186 225.649 241.001 226.87C251.247 230.02 263.996 232.89 275.727 233.673C275.718 233.51 275.708 233.347 275.702 233.184Z",
    fill: "#0074EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.363 174.48C250.363 174.48 251.922 181.196 259.49 181.057C267.198 180.918 267.885 174.458 267.885 174.458L262.851 173.387L262.43 167.809L254.856 168.367L254.716 173.666L250.364 174.481L250.363 174.48Z",
    fill: "url(#paint8_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.916 152.004C255.916 152.004 247.236 168.722 257.532 172.777C264.795 175.638 269.348 161.675 267.99 157.894C265.89 152.047 264.507 152.741 264.507 152.741L255.916 152.004H255.916Z",
    fill: "url(#paint9_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.082 150.483C274.37 151.655 270.705 160.901 264.25 158.715C257.794 156.529 255.257 156.561 254.251 158.323C253.245 160.085 253.029 166.345 250.846 163.251C248.453 159.859 247.119 153.051 250.053 150.856C252.675 148.895 253.287 145.853 256.432 145.958C260.606 146.098 263.835 144.258 265.72 145.585C267.884 147.109 266.927 149.62 270.082 150.482V150.483Z",
    fill: "#243862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.851 159.759C253.851 159.759 252 157.779 251.703 160.166C251.407 162.553 252.358 165.627 253.473 163.942C254.587 162.257 253.851 159.759 253.851 159.759H253.851Z",
    fill: "url(#paint10_linear_7054_22789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.239 205.11C261.239 206.328 260.435 207.316 259.211 207.316C257.986 207.316 256.992 206.328 256.992 205.11C256.992 203.892 257.717 202.788 258.942 202.789C260.167 202.789 261.239 203.892 261.239 205.11Z",
    fill: "url(#paint11_linear_7054_22789)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7054_22789",
    x1: 279.683,
    y1: 129.2,
    x2: 261.498,
    y2: 155.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7054_22789",
    x1: 233.581,
    y1: 185.221,
    x2: 262.61,
    y2: 255.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7054_22789",
    x1: 285.545,
    y1: 185.07,
    x2: 256.516,
    y2: 255.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7054_22789",
    x1: 259.619,
    y1: 194.307,
    x2: 258.112,
    y2: 255.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7054_22789",
    x1: 277.214,
    y1: 231.241,
    x2: 293.232,
    y2: 231.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7054_22789",
    x1: 287.786,
    y1: 202.524,
    x2: 271.047,
    y2: 248.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7054_22789",
    x1: 238.33,
    y1: 231.191,
    x2: 222.309,
    y2: 230.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7054_22789",
    x1: 253.908,
    y1: 188.8,
    x2: 237.159,
    y2: 234.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7054_22789",
    x1: 259.316,
    y1: 191.032,
    x2: 258.93,
    y2: 157.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7054_22789",
    x1: 258.181,
    y1: 172.301,
    x2: 264.062,
    y2: 143.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7054_22789",
    x1: 254.243,
    y1: 176.127,
    x2: 250.026,
    y2: 130.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7054_22789",
    x1: 261.712,
    y1: 189.838,
    x2: 253.922,
    y2: 236.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7054_22789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.7578,
    height: 89.9633,
    fill: "white",
    transform: "translate(222.961 145.102)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivation2);
export default __webpack_public_path__ + "static/media/activation2.d47eaa727e7436770131f4ba2dcc1e9f.svg";
export { ForwardRef as ReactComponent };